import React from "react";
import { motion } from "framer-motion";

function MultimediaSolutionsFeatures() {
  const features = [
    {
      title: "Video Production & Editing",
      description:
        "Craft high-quality videos, from corporate films to product promos, with professional editing, motion graphics, and visual effects.",
      color: "#1E88E5",
    },
    {
      title: "2D & 3D Animation",
      description:
        "Bring ideas to life with stunning 2D and 3D animations for advertisements, explainer videos, training, and entertainment.",
      color: "#43A047",
    },
    {
      title: "Interactive Presentations",
      description:
        "Engage audiences with dynamic, interactive multimedia presentations designed for corporate, educational, and marketing needs.",
      color: "#FB8C00",
    },
    {
      title: "AR/VR Solutions",
      description:
        "Create immersive Augmented Reality (AR) and Virtual Reality (VR) experiences for training, gaming, product demos, and simulations.",
      color: "#8E24AA",
    },
    {
      title: "Digital Advertising Media",
      description:
        "Develop multimedia-rich ads, social media content, and campaign visuals that grab attention across platforms and devices.",
      color: "#00ACC1",
    },
    {
      title: "E-Learning & Training Modules",
      description:
        "Design interactive learning modules and multimedia courses that simplify complex concepts and enhance knowledge retention.",
      color: "#F4511E",
    },
  ];

  // Smooth animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.35,
        duration: 1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeInOut" },
    },
  };

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "40px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "25px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
      padding: "25px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <motion.h2
        style={styles.heading}
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        Key Features of Our Multimedia Solutions
      </motion.h2>

      <motion.div
        style={styles.grid}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
            }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default MultimediaSolutionsFeatures;
